<!--
AnotherPlate
其他立牌
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌 > 其他立牌" name="其他立牌">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="anotherPlate" label-width="80px">
              <p>请描述您的需求</p>
              <el-input type="textarea" v-model="anotherPlate['需求']"></el-input>
              <br>
              <br>
              <center>
                <el-button v-on:click="addEvent()">提交</el-button>
                <el-button v-on:click="clear()">清空</el-button>
              </center>
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "AnotherPlate",
  data() {
    return {
      forcollapse: ["allsame"],
      anotherPlate: {
        title: "其他立牌"
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.anotherPlate);
    },
    clear() {
      this.$root.clearAlert();
      this.anotherPlate = {
        title: "其他立牌"
      };
    }
  }
};
</script>
<style scoped>
</style>